import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const limitedModePluginKey: PluginKey = new PluginKey('limitedModePlugin');
